import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'

import { IBeatDictionaryItem } from '../../../Interface/beat-dictionary'
import { FilterPropertyType, IdType, MultiSelectMode, SearchTitleType } from '../../../types/filter.type'

/**
 * Универсальный селект по справочнику атрибутов бита.
 * Одиночный режим используется для тональности и типа трека, множественный — для инструментов
 * (mat-select multiple рисует чекбоксы сам, отдельный MatCheckboxModule не нужен).
 */
@Component({
  selector: 'bmcore-dictionary-select',
  templateUrl: './bmcore-dictionary-select.component.html',
  styleUrls: ['./bmcore-dictionary-select.component.scss'],
  standalone: false
})
export class BmcoreDictionarySelectComponent {
  @Input() label: string
  /** подпись пункта «все»; задаётся только для одиночного режима */
  @Input() allOptionLabel: string
  @Input() items: IBeatDictionaryItem[] = []
  @Input() filterTitle: SearchTitleType
  @Input() multiple = false

  /** одиночный режим */
  @Input() value: IdType = 'all'
  /** множественный режим */
  @Input() selectedIds: number[] = []

  /** переключатель И/ИЛИ показываем только когда выбрано больше одного значения */
  @Input() mode: MultiSelectMode = 'and'
  @Input() showModeToggle = false
  @Input() andLabel: string
  @Input() orLabel: string

  @Output() filterTracksEvent = new EventEmitter<FilterPropertyType>()

  get isModeToggleVisible(): boolean {
    return this.multiple && this.showModeToggle && this.selectedIds?.length > 1
  }

  onSingleChange(event: MatSelectChange) {
    this.value = event.value
    this.filterTracksEvent.emit({ title: this.filterTitle, id: event.value })
  }

  onMultipleChange(event: MatSelectChange) {
    this.selectedIds = event.value ?? []
    this.emitMultiple()
  }

  toggleMode(mode: MultiSelectMode) {
    if (this.mode === mode) {
      return
    }

    this.mode = mode
    this.emitMultiple()
  }

  private emitMultiple() {
    this.filterTracksEvent.emit({
      title: this.filterTitle,
      ids: this.selectedIds,
      mode: this.mode
    })
  }
}
